import { render, staticRenderFns } from "./PredictionManagement.vue?vue&type=template&id=7c2adfd3&scoped=true"
import script from "./PredictionManagement.vue?vue&type=script&lang=js"
export * from "./PredictionManagement.vue?vue&type=script&lang=js"
import style0 from "./PredictionManagement.vue?vue&type=style&index=0&id=7c2adfd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2adfd3",
  null
  
)

export default component.exports